import { Component, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { debounceTime, filter, switchMap, tap } from 'rxjs/operators';
import { PAGE } from '@ap-angular/shared/schema';
import { ProviderService } from '@ap-angular/service/provider';
import { UserService } from '@ap-angular/service/user';
import { PersonListInfoDTO } from '@auto-generated/ap-platform/care-providers';
import { Router } from '@angular/router';

@Component({
	selector: 'ap-provider-institution-select',
	templateUrl: './institution-select.component.html',
	styleUrls: ['./institution-select.component.scss'],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProviderInstitutionSelectComponent {

	@Output() closeSidenav = new EventEmitter<boolean>();

	public readonly PAGE = PAGE;

	public loading = true;

	public opened: boolean;

	public list$: Observable<Array<PersonListInfoDTO>> = this.userService.readUsername$()
		.pipe(
			filter(username => !!username),
			tap(username => this.providerService.loadProviderList(username)),
			switchMap(() => this.providerService.getProviderList$()),
			debounceTime(100),
			tap(() => this._loading(false))
		);

	public defaultPid$: Observable<number> = this.userService.readDefaultPid$();

	public currentPid$: Observable<number> = this.userService.getCurrentPid$();

	constructor(
		private changeDetectorRef: ChangeDetectorRef,
		private providerService: ProviderService,
		private router: Router,
		private userService: UserService
		) {
	}

	public getCurrentPid(id: number, list: Array<PersonListInfoDTO>): PersonListInfoDTO {
		return list.find((item => item.id === id));
	}

	public setCurrentPid(id: number): void {
		this.userService.setCurrentPid(id);

		const url = this.router.url;

		if(url.includes(PAGE.PROVIDER_RESOURCE_ROOM.fullpath)) {
			this.router.navigate([PAGE.PROVIDER_RESOURCE_ROOM.fullpath]).then();
			return;
		}

		if(url.includes(PAGE.PROVIDER_RESOURCE.fullpath)) {
			this.router.navigate([PAGE.PROVIDER_RESOURCE.fullpath]).then();
			return;
		}

		if(url.includes(PAGE.PROVIDER_PATIENT.fullpath)) {
			this.router.navigate([PAGE.PROVIDER_PATIENT.fullpath]).then();
			return;
		}

		const pageFound = Object.values(PAGE).find(it => url.includes(it.fullpath));
		if (pageFound) return;
		
		this.router.navigate([PAGE.PROVIDER.fullpath]).then();

	}

	public goToLocationManagement(): void {
		this.router.navigate([PAGE.PROVIDER_INSTITUTION.fullpath]).then();
		this.closeSidenav.emit(true);
	}

	private _loading(value: boolean = false) {
		this.loading = value;
		this.changeDetectorRef.markForCheck();
	}
}
